import type { TileResourceCosts } from '@/plugins/tiles/contracts'

/** 容量满时保守拒绝未知项；不能靠淘汰失败峰值重新完整读取。 */
export class TileCostHistory {
  private readonly _costs = new Map<string, TileResourceCosts>()

  constructor(private readonly _limit = 4096) {}

  get(identity: string): TileResourceCosts | undefined {
    return this._costs.get(identity)
  }

  get saturated(): boolean {
    return this._costs.size >= this._limit
  }

  remember(identity: string, costs: TileResourceCosts): boolean {
    const previous = this._costs.get(identity)
    if (!previous && this.saturated) return false
    const memory =
      costs.memory && previous?.memory
        ? {
            cpuBytes: Math.max(costs.memory.cpuBytes, previous.memory.cpuBytes),
            gpuBytes: Math.max(costs.memory.gpuBytes, previous.memory.gpuBytes),
          }
        : (costs.memory ?? previous?.memory)
    this._costs.set(
      identity,
      Object.freeze({
        inputBytes: Math.max(costs.inputBytes, previous?.inputBytes ?? 0),
        geometryBytes: Math.max(costs.geometryBytes, previous?.geometryBytes ?? 0),
        textureBytes: Math.max(costs.textureBytes, previous?.textureBytes ?? 0),
        transientBytes: Math.max(costs.transientBytes, previous?.transientBytes ?? 0),
        cpuTextureBytes:
          costs.cpuTextureBytes === undefined && previous?.cpuTextureBytes === undefined
            ? undefined
            : Math.max(costs.cpuTextureBytes ?? 0, previous?.cpuTextureBytes ?? 0),
        gpuTextureBytes:
          costs.gpuTextureBytes === undefined && previous?.gpuTextureBytes === undefined
            ? undefined
            : Math.max(costs.gpuTextureBytes ?? 0, previous?.gpuTextureBytes ?? 0),
        memory,
      })
    )
    return true
  }
}
